@for (card of smallCardsData().cards; track card.id) {
  <div class="rounded-2xl flex flex-col overflow-hidden flex-1">
    @if (card.image) {
      <ss-www-image-with-loader
        [class]="imageAspectRatio()"
        [fileDetail]="card.image"
        desktopImageSize="half"
      ></ss-www-image-with-loader>
    }
    <div
      class="bg-black p-6 grow"
      [class.border-t]="!!card.image"
      [class.border-ss-gold]="!!card.image"
    >
      <div
        [innerHTML]="card.text"
        [ssDirectus]="{
          collection: 'smallCardItems',
          item: card.id,
          fields: ['text'],
        }"
      ></div>
      @if (card.buttons?.length) {
        <div class="flex flex-wrap pt-4 gap-4">
          @for (button of card.buttons; track button.id) {
            <ss-building-block-button-link
              [buttonLink]="button.item"
            ></ss-building-block-button-link>
          }
        </div>
      }
    </div>
  </div>
}
